import { render, staticRenderFns } from "./last-wins.vue?vue&type=template&id=81e6884a&scoped=true&"
import script from "./last-wins.vue?vue&type=script&lang=js&"
export * from "./last-wins.vue?vue&type=script&lang=js&"
import style0 from "./last-wins.vue?vue&type=style&index=0&id=81e6884a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e6884a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81e6884a')) {
      api.createRecord('81e6884a', component.options)
    } else {
      api.reload('81e6884a', component.options)
    }
    module.hot.accept("./last-wins.vue?vue&type=template&id=81e6884a&scoped=true&", function () {
      api.rerender('81e6884a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/last-wins.vue"
export default component.exports